console.log('✅ horizontal-nav-bar-for-categories.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { loadTextTranslations } from '../../js/translator.js';
import {
  initLinksTranslator,
  getLinksTranslationByKeyFromCurrentLanguageProxy,
} from '../../js/router-routes-manager.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import {
  fetchAllCategories,
  fetchAllSubcatgoriesInCategory,
  fetchAllProductsInSubcatgory,
} from '../../services/data-services/catalog-data-service.js';

let _tempTextTranslator = null;

export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

const lang = appState.SiteLanguageCookie;

let isDropdownOpen = false;

let MOUSE_LOCS_TRACKED = 3; // number of past mouse locations to track
let DELAY = 300; // ms delay when user appears to be entering submenu
let mouseLocs = [];
let lastDelayLoc = null;

let timeoutId = null;

/**
 * Keep track of the last few locations of the mouse.
 */
//var timer;
//var oldx;
// var oldy;
let VerticalDropDownMainActiveRow = null;
let tolerance = 75; // bigger = more forgivey when entering submenu

let mouseMovingStatus = false;
let submenuDirection = 'right'; // left, below, above

// for horizonal top Nav

let MOUSE_LOCS_TRACKEDHorizontal = 3; // number of past mouse locations to track
var DELAYHorizontal = 300; // ms delay when user appears to be entering submenu
let mouseLocsHorizontal = [];
let lastDelayLocHorizontal = null;

let timeoutIdHorizontal = null;

/**
 * Keep track of the last few locations of the mouse.
 */
let timerHorizontal;

let HorizontalDropDownMainActiveRow = null;
let toleranceHorizontal = -75; // bigger = more forgivey when entering submenu

let submenuDirectionHorizontal = 'below'; // left, below, above, right

// end for horizonal top Nav

/**
 * Builds the “Ship To Country” toggle + dropdown for the sidebar
 */
export async function buildComponentHorizontalNavBarForCategories() {
  console.log(`🔄 Building Component: HorizontalNavBarForCategories - lang: ${lang}`);
  try {
    // 1️⃣ Load translations
    await initTempTextTranslator(lang);
    await initTempLinksTranslator(lang);

    const { keyAllCategories: lblAllCategories, keyBlogHome: lblBlogHome } = _tempTextTranslator;

    const { keyCategory: linkCategory } = _tempLinksTranslator;

    // const dtHomePageTopNavDepartments = [];
    const dtHomePageTopNavDepartments = await fetchAllCategories();

    const dtHomePageTopNavDepartmentsHTML = dtHomePageTopNavDepartments
      // only the ones marked for the home‐page sidebar
      .filter(b => b.isOnHomePageTopNav === true)
      // then map to your <a> tags
      .map(b => {
        const link = `${linkCategory}/${b.departmentID}/${b.seoPageName}`;
        return `
                    <a href="${link}" data-close-on-click-top-horizontal-nav>   ${b.name} </a>`;
      })
      .join('');

    // const htmlPromises = filtered.map(async (b, idx) => {

    // const dtHomePageSideNavDepartmentsHTML = "";

    const dtHomePageSideNavDepartmentsHTML = dtHomePageTopNavDepartments
      // only the ones marked for the home‐page sidebar
      .filter(b => b.isOnHomePageSideNav === true)
      // then map to your <a> tags
      .map((b, idx) => {
        const link = `${linkCategory}/${b.departmentID}/${b.seoPageName}`;
        return `
                    

                     <div class="VerticalDropDownMainContainer_list_Item ${
                       idx === 0 ? 'VerticalDropDownMainContainer_list_Item_Label_Active' : ''
                     }">

                                            <a href="${link}" data-close-on-click-top-horizontal-nav>  ${
          b.name
        }  </a>


                                        </div>

                                        `;
      })
      .join('');

    // const mainDropDownWithAllCategoriesSection = "";
    const mainDropDownWithAllCategoriesSection = await buildMainSection();

    const html = `

        <center>
     
        <div class="HorizontalNavBarcontainer" id="MainTopHorizontalNavBar">

           <div id="topNavAllCategoriesWholeContainer" class="dropdownHorizontalNavBarcontainer">


        <button class="dropbtnHorizontalNavBar" id="btnToogleTopNavAllCat">         

                    <svg id="ImageToogleTopNavAllCat" fill="#555" height="20px" width="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="cartTopNewButton-Image cartTopNewButton-Image-toggle-icon">
              <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"></path>
              </svg>

                    ${lblAllCategories}
                </button>

         
           <div id="topNavAllCategoriesContents" class="dropdownHorizontalNavBar-content" style="border: 0px solid pink;height: auto;display:none;">

                    <div class="NewHeaderDropdown-ValidContentArea">

                                <div class="basicTable" style="border: 0px solid yellow;width:100%;top:0;bottom:0;">
                                    <div class="basicTableRow">
                                        <div class="basicTableCell" style="border: 0px solid yellow;vertical-align:top;width:20%;">
                                            <div class="VerticalDropDownMainContainer_list" id="DepartmentListTopNavAll_list" style="border: 0px solid purple;">       

                                            ${dtHomePageSideNavDepartmentsHTML}


                                             </div>  

                                          </div>    


                                           ${mainDropDownWithAllCategoriesSection}
                                    </div>    
                                  </div>    
                       </div>    
                  </div>    

             </div>    
      
          ${dtHomePageTopNavDepartmentsHTML}


      </div>


       </center>

      `;

    console.log('✅ HorizontalNavBarForCategories built successfully.');
    // 4️⃣ Defer event wiring until after insertion
    registerEventListenerToAttach(async () => initComponentHorizontalNavBarForCategories());
    return html;
  } catch (err) {
    console.error('❌ Error building HorizontalNavBarForCategories:', err);
    return `<div class="error">Error loading HorizontalNavBarForCategories</div>`;
  }
}

async function buildMainSection() {
  const sectionHTML = await buildSubSectionCategories();

  const html = `

      <div class="basicTableCell" style="border: 1px solid #e7e7e7;vertical-align:top;width:80%;position:relative;">
                            <div class="HorizontalDropDownMainContainer" style="">

    
    ${sectionHTML}


      </div>

                        </div>

                        `;

  return html;
}

export async function buildSubSectionCategories() {
  const depts = await fetchAllCategories(); // fetch your departments
  const { keyCategory: linkCategory } = _tempLinksTranslator;

  // only keep the ones meant for the home‐page sidebar
  const filtered = depts.filter(b => b.isOnHomePageSideNav);

  // map to an array of Promises returning HTML strings
  const htmlPromises = filtered.map(async (b, idx) => {
    const link = `${linkCategory}/${b.departmentID}/${b.seoPageName}`;
    // await each sub‐category block
    const subcatsHtml = await buildSubSectionSubcategories(b.departmentID, b.seoPageName);

    const productsIncatsHtml = await buildSubSectionProducts(b.departmentID, b.seoPageName);

    return `
      <div class="HorizontalDropDownMainContainer_wrapper ${
        idx === 0 ? 'HorizontalDropDownMainContainer_wrapper_Active' : ''
      }">
        <div class="HorizontalDropDownMainContainer_list_Title">
          <a href="${link}" style="border-bottom: 3px solid #8dc63f;" data-close-on-click-top-horizontal-nav>
            ${b.name}
          </a>
        </div>
        <div class="HorizontalDropDownMainContainer_list" style="border: 0px solid #ccc;">
          ${subcatsHtml} 
        </div>

           <div style="border: 0px solid #8dc63f;">
            ${productsIncatsHtml} 
                  

                                                  

                   
           </div>
      </div>
    `;
  });

  // wait for all of them to resolve, then join into one big chunk
  const htmlArray = await Promise.all(htmlPromises);
  return htmlArray.join('');
}

export async function buildSubSectionSubcategories(
  selectedDepartmentID,
  selectedDepartmentSEOPageName
) {
  // ❶ fetch all sub-cats for this department
  const subcats = await fetchAllSubcatgoriesInCategory(selectedDepartmentID);

  // ❷ only the ones marked for the HomePage sidebar
  // const filtered = subcats.filter(s => s.isOnHomePageTopNav === true);

  const filtered = subcats;

  // ❸ map → HTML
  const html = filtered
    .map(s => {
      // build your URL however you need
      const link =
        `/${appState.SiteLanguageCookie}` +
        `/${selectedDepartmentID}` +
        `/${selectedDepartmentSEOPageName}` +
        `/${s.categoryID}` +
        `/${s.seoPageName}`;

      return `
        <div class="HorizontalDropDownMainContainer_list_Item">
          <a href="${link}" data-close-on-click-top-horizontal-nav>${s.name}</a>
        </div>
      `;
    })
    .join('');

  return html;
}

export async function buildSubSectionProducts(selectedDepartmentID, selectedDepartmentSEOPageName) {
  // ❶ load all sub‐categories for this category
  const subcats = await fetchAllSubcatgoriesInCategory(selectedDepartmentID);

  // ❷ (optional) filter if you only want certain subcats:
  // const filtered = subcats.filter(s => s.isOnHomePageSideNav);
  const filtered = subcats;

  // ❸ kick off all the async renders in parallel,
  //     and await them all before joining
  const htmlSegments = await Promise.all(
    filtered.map(async (s, idx) => {
      // build the URL for this sub‐category
      const link =
        `/${appState.SiteLanguageCookie}` +
        `/${selectedDepartmentID}` +
        `/${selectedDepartmentSEOPageName}` +
        `/${s.categoryID}` +
        `/${s.seoPageName}`;

      // build your inner products list (replace `buildProductsInSubcategory`
      // with however you actually fetch/render the products)
      const productsHtml = await buildProductsInSubcategory(
        selectedDepartmentID,
        selectedDepartmentSEOPageName,
        s.categoryID,
        s.seoPageName
      );

      return `
        <div class="HorizontalDropDownMainContainer_Sublist_wrapper
                    ${idx === 0 ? 'HorizontalDropDownMainContainer_Sublist_wrapper_Active' : ''}">
          <div class="HorizontalDropDownMainContainer_Sublist_Title">
            <div class="HorizontalDropDownMainContainer_Sublist_Title-LinkSpan">


              <a href="${link}" data-close-on-click-top-horizontal-nav>
                ${s.name}
              </a>
            </div>
          </div>
          <div class="HorizontalDropDownMainContainer_Sublist">
            ${productsHtml}
          </div>
        </div>
      `;
    })
  );

  // ❹ concatenate into one giant string
  return htmlSegments.join('');
}

async function buildProductsInSubcategory(
  selectedDepartmentID,
  selectedDepartmentSEOPageName,
  selectedCategoryID,
  selectedCategorySEOPageName
) {
  // ❶ fetch all products for this sub-category
  const products = await fetchAllProductsInSubcatgory(selectedCategoryID);
  // ❷ only the ones marked for the HomePage sidebar
  // const filtered = products.filter(s => s.isOnHomePageTopNav === true);
  const filtered = products;
  // ❸ map → HTML
  const html = filtered
    .map(s => {
      // build your URL however you need
      const link =
        `/${appState.SiteLanguageCookie}` +
        `/${selectedDepartmentID}` +
        `/${selectedDepartmentSEOPageName}` +
        `/${selectedCategoryID}` +
        `/${selectedCategorySEOPageName}` +
        `/${s.productID}` +
        `/${s.seoPageName}`;
      return `
        <div class="HorizontalDropDownMainContainer_Sublist_Item">
          <a href="${link}" data-close-on-click-top-horizontal-nav>${s.name}</a>
        </div>
      `;
    })
    .join('');
  return html;
}

export async function initComponentHorizontalNavBarForCategories() {
  try {
    await setupGeneralListeners();

    console.log('✅ HorizontalNavBarForCategories listeners attached.');
  } catch (err) {
    console.error('❌ Error attaching HorizontalNavBarForCategories listeners:', err);
  }
}

export async function setupGeneralListeners() {
  const button = document.getElementById('btnToogleTopNavAllCat');
  if (!button) return;

  const dropdownContent = document.getElementById('topNavAllCategoriesContents');
  if (!dropdownContent) return;

  const onNavToggleClick = async () => handleNavToggle();
  button.removeEventListener('click', onNavToggleClick);
  button.addEventListener('click', onNavToggleClick);

  // Handle Vertical List Items
  const verticalItems = dropdownContent.querySelectorAll(
    '.VerticalDropDownMainContainer_list_Item'
  );
  verticalItems.forEach(element => {
    const onMouseEnter = () => VerticalDropDownMainContainerMouseOverOld(element);
    const onMouseLeave = () => VerticalDropDownMainContainerMouseOutOld(element);

    element.removeEventListener('mouseenter', onMouseEnter);
    element.removeEventListener('mouseleave', onMouseLeave);

    element.addEventListener('mouseenter', onMouseEnter);
    element.addEventListener('mouseleave', onMouseLeave);
  });

  // Handle Horizontal List Items
  const horizontalItems = dropdownContent.querySelectorAll(
    '.HorizontalDropDownMainContainer_list_Item'
  );
  horizontalItems.forEach(element => {
    const onMouseOver = () => TopNavAllCatInDeptCatSelectMouseEnter(element);
    const onMouseOut = () => TopNavAllCatInDeptCatSelectMouseLeave(element);

    element.removeEventListener('mouseover', onMouseOver);
    element.removeEventListener('mouseout', onMouseOut);

    element.addEventListener('mouseover', onMouseOver);
    element.addEventListener('mouseout', onMouseOut);
  });

  // Handle Close-on-Click Links
  const closeOnClickLinks = dropdownContent.querySelectorAll(
    '[data-close-on-click-top-horizontal-nav]'
  );
  closeOnClickLinks.forEach(element => {
    const onClick = () => handleCloseDropdownOnly();
    element.removeEventListener('click', onClick);
    element.addEventListener('click', onClick);
  });

  // Global Listeners (add only once globally, remove if re-running is needed)
  document.removeEventListener('click', onDocumentClick);
  document.removeEventListener('mousemove', onDocumentMouseMove);

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('mousemove', onDocumentMouseMove);
}

//async function setupGeneralListeners() {

//    const button = document.getElementById("btnToogleTopNavAllCat");
//    if (!button) return;

//    const dropdownContent = document.getElementById("topNavAllCategoriesContents");
//    if (!dropdownContent) return;

//    const buttonClone = button.cloneNode(true);
//    button.parentNode.replaceChild(buttonClone, button);

//    // CLICK on  button
//    addListenerViaCurrentlyAttachedListenersRegistry(buttonClone, "click", async () => {

//        handleNavToggle();

//      });

//    //add VerticalDropDownMainContainerMouseOverOld to all items in the list VerticalDropDownMainContainer_list_Item

//    const querySelector = dropdownContent.querySelectorAll(".VerticalDropDownMainContainer_list_Item");
//    if (querySelector) {
//        for (let i = 0; i < querySelector.length; i++) {
//            const element = querySelector[i];
//            const clone = element.cloneNode(true);
//            element.replaceWith(clone);

//            //mouseenter //mouseover

//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "mouseenter", (e) => {

//                VerticalDropDownMainContainerMouseOverOld(clone);
//            });

//            //mouseleave //mouseout
//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "mouseleave", (e) => {
//                VerticalDropDownMainContainerMouseOutOld(clone);

//            });

//        }
//    }

//    // add HorizontalDropDownMainContainerMouseOverOld to all items in the list HorizontalDropDownMainContainer_list_Item

//    const querySelectorHorizontal = dropdownContent.querySelectorAll(".HorizontalDropDownMainContainer_list_Item");
//    if (querySelectorHorizontal) {
//        for (let i = 0; i < querySelectorHorizontal.length; i++) {
//            const element = querySelectorHorizontal[i];
//            const clone = element.cloneNode(true);
//            element.replaceWith(clone);

//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "mouseover", (e) => {
//                TopNavAllCatInDeptCatSelectMouseEnter(clone);
//            });

//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "mouseout", (e) => {
//                TopNavAllCatInDeptCatSelectMouseLeave(clone);
//            });

//        }
//    }

//    // add close on click to all links with data-close-on-click-top-horizontal-nav
//    const querySelectorCloseOnClick = dropdownContent.querySelectorAll("[data-close-on-click-top-horizontal-nav]");

//    if (querySelectorCloseOnClick) {
//        for (let i = 0; i < querySelectorCloseOnClick.length; i++) {
//            const element = querySelectorCloseOnClick[i];
//            const clone = element.cloneNode(true);
//            element.replaceWith(clone);

//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", (e) => {
//                handleCloseDropdownOnly();
//            }
//            );

//        }
//    }

//    // ➊ Listen globally for clicks…
//    document.addEventListener("click", onDocumentClick);

//    // ➋ Listen globally for mouse movements…
//    document.addEventListener("mousemove", onDocumentMouseMove);

//}

async function handleNavToggle() {
  const dropdownContent = document.getElementById('topNavAllCategoriesContents');
  const icon = document.getElementById('ImageToogleTopNavAllCat');
  if (!dropdownContent || !icon) return;

  isDropdownOpen = !isDropdownOpen;
  dropdownContent.style.display = isDropdownOpen ? 'block' : 'none';

  // rotate the icon
  icon.classList.toggle('cartTopNewButton-Image-toggle-icon-rotated', isDropdownOpen);
}

function handleCloseDropdownOnly() {
  const dropdownContent = document.getElementById('topNavAllCategoriesContents');
  const icon = document.getElementById('ImageToogleTopNavAllCat');
  if (!dropdownContent) return;

  isDropdownOpen = false;
  dropdownContent.style.display = 'none';
  if (icon) icon.classList.remove('cartTopNewButton-Image-toggle-icon-rotated');
}

function onDocumentClick(event) {
  const button = document.getElementById('btnToogleTopNavAllCat');
  const dropdownContent = document.getElementById('topNavAllCategoriesContents');

  if (
    isDropdownOpen &&
    dropdownContent &&
    button &&
    !dropdownContent.contains(event.target) &&
    !button.contains(event.target)
  ) {
    handleCloseDropdownOnly();
  }
}

//function handleCloseDropdownOnly() {
//    const dropdownContent = document.getElementById("topNavAllCategoriesContents");
//    if (!dropdownContent) return;
//    isDropdownOpen = false;
//    dropdownContent.style.display = "none";

//}

//function onDocumentClick(event) {

//    const button = document.getElementById("btnToogleTopNavAllCat");
//    const dropdownContent = document.getElementById("topNavAllCategoriesContents");

//        if (isDropdownOpen
//            && dropdownContent
//            && button
//            && !dropdownContent.contains(event.target)
//            && !button.contains(event.target)) {
//            isDropdownOpen = false;
//            dropdownContent.style.display = "none";
//        }

//}

function onDocumentMouseMove(event) {
  document.onmousemove = function(e) {
    /**
     * Keep track of the last few locations of the mouse.
     */
    mouseLocs.push({ x: e.pageX, y: e.pageY });

    if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
      mouseLocs.shift();
    }

    mouseLocsHorizontal.push({ x: e.pageX, y: e.pageY });
    if (mouseLocsHorizontal.length > MOUSE_LOCS_TRACKEDHorizontal) {
      mouseLocsHorizontal.shift();
    }
  };
}

function slope(a, b) {
  return (b.y - a.y) / (b.x - a.x);
}

//function VerticalDropDownMainContainerMouseOverOldMain(obj) {

//  //  alert(`VerticalDropDownMainContainerMouseOverOldMain obj: ${obj}`);

//    if (timeoutId) {
//        // Cancel any previous activation delays
//        clearTimeout(timeoutId);
//    }

//    if (obj) {

//        let objPosition = "";
//        let elementContainer = document.getElementById("DepartmentListTopNavAll_list");

//        if (elementContainer) {

//            // alert("element found");
//            let elementItems = document.getElementsByClassName("VerticalDropDownMainContainer_list_Item");

//            for (let i = 0; i < elementItems.length; i++) {

//                let tempEelement = elementItems[i];
//                if (tempEelement.classList.contains('VerticalDropDownMainContainer_list_Item_Label_Active')) {
//                    tempEelement.classList.remove('VerticalDropDownMainContainer_list_Item_Label_Active');
//                }

//                if (obj == tempEelement) {
//                    objPosition = i;

//                }
//            }

//            if (obj.classList.contains('VerticalDropDownMainContainer_list_Item_Label_Active')) {

//            }
//            else {
//                obj.classList.add('VerticalDropDownMainContainer_list_Item_Label_Active');

//            }

//            //   // find corresponding category tab and show
//              ShowOrHideCorrespondinginCatDiv(objPosition);

//        }

//    }
//    else {
//        // alert("obj not found");
//        console.log("obj not found");
//    }
//}

function VerticalDropDownMainContainerMouseOverOld(obj) {
  if (timeoutId) {
    // Cancel any previous activation delays
    clearTimeout(timeoutId);
  }

  // options.enter(this);
  possibleActivation(obj);
}

function VerticalDropDownMainContainerMouseOutOld(obj) {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
}

function TopNavAllCatInDeptCatSelectMouseEnter(obj) {
  if (timeoutIdHorizontal) {
    // Cancel any previous activation delays
    clearTimeout(timeoutIdHorizontal);
  }

  // options.enter(this);
  possibleActivationHorizontal(obj);
}

function TopNavAllCatInDeptCatSelectMouseLeave(obj) {
  if (timeoutIdHorizontal) {
    clearTimeout(timeoutIdHorizontal);
  }
}

function VerticalDropDownMainContainerClicked(obj) {
  let objPosition = '';
  let elementContainer = document.getElementById('DepartmentListTopNavAll_list');

  if (elementContainer) {
    // alert("element container found");
    let elementItems = document.getElementsByClassName('VerticalDropDownMainContainer_list_Item');

    for (let i = 0; i < elementItems.length; i++) {
      let tempEelement = elementItems[i];
      if (tempEelement.classList.contains('VerticalDropDownMainContainer_list_Item_Label_Active')) {
        tempEelement.classList.remove('VerticalDropDownMainContainer_list_Item_Label_Active');
      }

      //  alert(elementItems.id);

      if (obj == tempEelement) {
        objPosition = i;
        //   alert("same elemet");
      }
    }

    if (obj.classList.contains('VerticalDropDownMainContainer_list_Item_Label_Active')) {
    } else {
      obj.classList.add('VerticalDropDownMainContainer_list_Item_Label_Active');
    }

    //   alert(obj.id);

    // find corresponding category tab and show
    ShowOrHideCorrespondinginCatDiv(objPosition);

    //  alert(elementItems);
  } else {
    //  alert("element container  not found");
  }
}

function TopNavAllCatInDeptCatSelectMouseClick(obj) {
  //  alert("hovered");
  let objPosition = '';

  // HorizontalDropDownMainContainer_list

  let elementContainer = document.getElementsByClassName(
    'HorizontalDropDownMainContainer_wrapper HorizontalDropDownMainContainer_wrapper_Active'
  )[0];

  // elementContainer.style.backgroundColor = "purple";

  //  let elementContainer = document.getElementsByClassName("HorizontalDropDownMainContainer_wrapper HorizontalDropDownMainContainer_wrapper_Active")[0];

  if (elementContainer) {
    // alert("element found");

    let elementItems = elementContainer.getElementsByClassName(
      'HorizontalDropDownMainContainer_list_Item'
    );

    for (let i = 0; i < elementItems.length; i++) {
      let tempEelement = elementItems[i];

      if (obj == tempEelement) {
        objPosition = i;

        // alert("objPosition " + objPosition);

        // obj.style.backgroundColor = "#C8FF4E";

        if (obj.classList.contains('HorizontalDropDownMainContainer_list_Item_Active')) {
        } else {
          obj.classList.add('HorizontalDropDownMainContainer_list_Item_Active');
        }
      } else {
        // tempEelement.style.backgroundColor = "inherit";

        if (tempEelement.classList.contains('HorizontalDropDownMainContainer_list_Item_Active')) {
          tempEelement.classList.remove('HorizontalDropDownMainContainer_list_Item_Active');
        }
      }
      //   tempEelement.style.backgroundColor = "inherit";

      //   if (obj == tempEelement) {
      //        objPosition = i;
      //        //   alert("same elemet");
    }

    ShowOrHideCorrespondinginProductDiv(elementContainer, objPosition);
  }

  //  obj.style.backgroundColor = "#C8FF4E";

  //  }
}

function ActivateVerticalDropDownMainSingle(obj) {
  if (obj) {
    if (obj == VerticalDropDownMainActiveRow) {
      return;
    }
    // if there is another active cell deactive it

    if (VerticalDropDownMainActiveRow) {
      // tbc
      DeactivateVerticalDropDownMainSingle(VerticalDropDownMainActiveRow);
    }

    StartActivation(obj);

    VerticalDropDownMainActiveRow = obj;
  }
}

function DeactivateVerticalDropDownMainSingle(VerticalDropDownMainActiveRow) {
  //  let elementContainer = document.getElementById("DepartmentListTopNavAll_list");

  if (VerticalDropDownMainActiveRow) {
    //   alert("de activate ran");

    if (
      VerticalDropDownMainActiveRow.classList.contains(
        'VerticalDropDownMainContainer_list_Item_Label_Active'
      )
    ) {
      VerticalDropDownMainActiveRow.classList.remove(
        'VerticalDropDownMainContainer_list_Item_Label_Active'
      );
    }
  }

  VerticalDropDownMainActiveRow = null;
}

/**
 * Possibly activate a menu row. If mouse movement indicates that we
 * shouldn't activate yet because user may be trying to enter
 * a submenu's content, then delay and check again later.
 */

function possibleActivation(obj) {
  var delay = activationDelay();

  if (delay) {
    timeoutId = setTimeout(function() {
      possibleActivation(obj);
    }, delay);
  } else {
    ActivateVerticalDropDownMainSingle(obj);
  }
}

function possibleActivationHorizontal(obj) {
  var delay = activationDelayHorizontal();

  if (delay) {
    timeoutIdHorizontal = setTimeout(function() {
      possibleActivationHorizontal(obj);
    }, delay);
  } else {
    ActivateHorizontalDropDownMainSingle(obj);
  }
}

function activationDelay() {
  if (!VerticalDropDownMainActiveRow) {
    // If there is no other submenu row already active, then
    // go ahead and activate immediately.

    //    alert("no active row");
    return 0;
  }

  let elementItems = document.getElementsByClassName('VerticalDropDownMainContainer_list')[0];
  // let elementItems = document.getElementsByClassName("HorizontalDropDownMainContainer")[0];

  if (elementItems) {
    //    alert(elementItems);
  }
  var offset = getOffset(elementItems);

  // alert("offset.left " + offset.left + " xxx "+  "offset.top " + offset.top);

  let upperLeft = {
    x: offset.left,
    y: offset.top - tolerance,
  };

  let upperRight = {
    x: offset.left + elementItems.offsetWidth,
    y: upperLeft.y,
  };

  let lowerLeft = {
    x: offset.left,
    y: offset.top + elementItems.offsetHeight + tolerance,
  };

  let lowerRight = {
    x: offset.left + elementItems.offsetWidth,
    y: lowerLeft.y,
  };

  let loc = mouseLocs[mouseLocs.length - 1];
  let prevLoc = mouseLocs[0];

  if (!loc) {
    //  alert("no location");

    return 0;
  }

  if (!prevLoc) {
    prevLoc = loc;
  }

  if (
    prevLoc.x < offset.left ||
    prevLoc.x > lowerRight.x ||
    prevLoc.y < offset.top ||
    prevLoc.y > lowerRight.y
  ) {
    // If the previous mouse location was outside of the entire
    // menu's bounds, immediately activate.

    //  alert(" trt ");
    return 0;
  }

  if (lastDelayLoc && loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
    // If the mouse hasn't moved since the last time we checked
    // for activation status, immediately activate.

    //   alert(" bbbt ");
    return 0;
  }

  // Detect if the user is moving towards the currently activated
  // submenu.
  //
  // If the mouse is heading relatively clearly towards
  // the submenu's content, we should wait and give the user more
  // time before activating a new row. If the mouse is heading
  // elsewhere, we can immediately activate a new row.
  //
  // We detect this by calculating the slope formed between the
  // current mouse location and the upper/lower right points of
  // the menu. We do the same for the previous mouse location.
  // If the current mouse location's slopes are
  // increasing/decreasing appropriately compared to the
  // previous's, we know the user is moving toward the submenu.
  //
  // Note that since the y-axis increases as the cursor moves
  // down the screen, we are looking for the slope between the
  // cursor and the upper right corner to decrease over time, not
  // increase (somewhat counterintuitively).

  var decreasingCorner = upperRight;
  var increasingCorner = lowerRight;

  //  alert("upper right corner" + decreasingCorner);

  // Our expectations for decreasing or increasing slope values
  // depends on which direction the submenu opens relative to the
  // main menu. By default, if the menu opens on the right, we
  // expect the slope between the cursor and the upper right
  // corner to decrease over time, as explained above. If the
  // submenu opens in a different direction, we change our slope
  // expectations.
  if (submenuDirection == 'left') {
    decreasingCorner = lowerLeft;
    increasingCorner = upperLeft;
  } else if (submenuDirection == 'below') {
    decreasingCorner = lowerRight;
    increasingCorner = lowerLeft;
  } else if (submenuDirection == 'above') {
    decreasingCorner = upperLeft;
    increasingCorner = upperRight;
  }

  //    alert("decreasingCorner x" + decreasingCorner.x + "  y" + decreasingCorner.y);
  //   alert("increasingCorner x" + increasingCorner.x + "  y" +  increasingCorner.y);

  var decreasingSlope = slope(loc, decreasingCorner);
  var increasingSlope = slope(loc, increasingCorner);
  var prevDecreasingSlope = slope(prevLoc, decreasingCorner);
  var prevIncreasingSlope = slope(prevLoc, increasingCorner);

  //  alert("decreasingSlope " + decreasingSlope);
  //  alert("increasingSlope " + increasingSlope);
  //  alert("prevDecreasingSlope " + prevDecreasingSlope);
  // alert("prevIncreasingSlope " + prevIncreasingSlope);

  if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
    // Mouse is moving from previous location towards the
    // currently activated submenu. Delay before activating a
    // new menu row, because user may be moving into submenu.

    //  alert("returning delay");

    lastDelayLoc = loc;
    return DELAY;
  }

  lastDelayLoc = null;
  return 0;
}

function activationDelayHorizontal() {
  if (!HorizontalDropDownMainActiveRow) {
    // If there is no other submenu row already active, then
    // go ahead and activate immediately.

    //    alert("no active row");
    return 0;
  }

  //  alert(HorizontalDropDownMainActiveRow);
  // let elementItems = document.getElementsByClassName("VerticalDropDownMainContainer_list")[0];
  // let elementItems = document.getElementsByClassName("HorizontalDropDownMainContainer")[0]; ** kidna working
  let elementItems = document.getElementsByClassName('HorizontalDropDownMainContainer')[0];
  //   let elementItems = HorizontalDropDownMainActiveRow;
  //  let elementItems = document.getElementsByClassName("HorizontalDropDownMainContainer_wrapper_Active")[0];

  //   let elementItems = document.getElementsByClassName("HorizontalDropDownMainContainer_Sublist_wrapper")[0];

  // elementItems.style.backgroundColor = "purple";

  //  let elementItems = document.getElementsByClassName("HorizontalDropDownMainContainer_Sublist_wrapper HorizontalDropDownMainContainer_Sublist_wrapper_Active")[0];
  // let elementItems = document.getElementsByClassName("HorizontalDropDownMainContainer_Sublist_wrapper HorizontalDropDownMainContainer_Sublist_wrapper_Active")[0];

  if (elementItems) {
    // alert(elementItems);
  }
  var offset = getOffset(elementItems);

  // alert("offset.left " + offset.left + " xxx "+  "offset.top " + offset.top);

  let upperLeft = {
    x: offset.left,
    y: offset.top - toleranceHorizontal,
  };

  let upperRight = {
    x: offset.left + elementItems.offsetWidth,
    y: upperLeft.y,
  };

  let lowerLeft = {
    x: offset.left,
    y: offset.top + elementItems.offsetHeight + toleranceHorizontal,
  };

  let lowerRight = {
    x: offset.left + elementItems.offsetWidth,
    y: lowerLeft.y,
  };

  let loc = mouseLocsHorizontal[mouseLocsHorizontal.length - 1];
  let prevLoc = mouseLocsHorizontal[0];

  if (!loc) {
    // alert("no location");

    return 0;
  }

  if (!prevLoc) {
    prevLoc = loc;
  }

  if (
    prevLoc.x < offset.left ||
    prevLoc.x > lowerRight.x ||
    prevLoc.y < offset.top ||
    prevLoc.y > lowerRight.y
  ) {
    // If the previous mouse location was outside of the entire
    // menu's bounds, immediately activate.

    //  alert(" trt ");

    //  alert(HorizontalDropDownMainActiveRow.classList);
    return 0;
  }

  if (
    lastDelayLocHorizontal &&
    loc.x == lastDelayLocHorizontal.x &&
    loc.y == lastDelayLocHorizontal.y
  ) {
    // If the mouse hasn't moved since the last time we checked
    // for activation status, immediately activate.

    //   alert(" bbbt ");
    return 0;
  }

  // Detect if the user is moving towards the currently activated
  // submenu.
  //
  // If the mouse is heading relatively clearly towards
  // the submenu's content, we should wait and give the user more
  // time before activating a new row. If the mouse is heading
  // elsewhere, we can immediately activate a new row.
  //
  // We detect this by calculating the slope formed between the
  // current mouse location and the upper/lower right points of
  // the menu. We do the same for the previous mouse location.
  // If the current mouse location's slopes are
  // increasing/decreasing appropriately compared to the
  // previous's, we know the user is moving toward the submenu.
  //
  // Note that since the y-axis increases as the cursor moves
  // down the screen, we are looking for the slope between the
  // cursor and the upper right corner to decrease over time, not
  // increase (somewhat counterintuitively).

  var decreasingCorner = upperRight;
  var increasingCorner = lowerRight;

  //  alert("upper right corner" + decreasingCorner);

  // Our expectations for decreasing or increasing slope values
  // depends on which direction the submenu opens relative to the
  // main menu. By default, if the menu opens on the right, we
  // expect the slope between the cursor and the upper right
  // corner to decrease over time, as explained above. If the
  // submenu opens in a different direction, we change our slope
  // expectations.
  if (submenuDirectionHorizontal == 'left') {
    decreasingCorner = lowerLeft;
    increasingCorner = upperLeft;
  } else if (submenuDirectionHorizontal == 'below') {
    decreasingCorner = lowerRight;
    increasingCorner = lowerLeft;
  } else if (submenuDirectionHorizontal == 'above') {
    decreasingCorner = upperLeft;
    increasingCorner = upperRight;
  }

  //  alert("decreasingCorner x" + decreasingCorner.x + "  y" + decreasingCorner.y + " increasingCorner x" + increasingCorner.x + "  y" + increasingCorner.y);
  //  alert("increasingCorner x" + increasingCorner.x + "  y" +  increasingCorner.y);

  var decreasingSlope = slope(loc, decreasingCorner);
  var increasingSlope = slope(loc, increasingCorner);
  var prevDecreasingSlope = slope(prevLoc, decreasingCorner);
  var prevIncreasingSlope = slope(prevLoc, increasingCorner);

  //  alert("decreasingSlope " + decreasingSlope + " increasingSlope " + increasingSlope + " prevDecreasingSlope " + prevDecreasingSlope + " prevIncreasingSlope " + prevIncreasingSlope);
  //  alert("decreasingSlope " + decreasingSlope);
  //  alert("increasingSlope " + increasingSlope);
  //  alert("prevDecreasingSlope " + prevDecreasingSlope);
  // alert("prevIncreasingSlope " + prevIncreasingSlope);

  if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
    // Mouse is moving from previous location towards the
    // currently activated submenu. Delay before activating a
    // new menu row, because user may be moving into submenu.

    //   alert("returning delay");

    lastDelayLocHorizontal = loc;
    return DELAYHorizontal;
  }

  lastDelayLocHorizontal = null;
  return 0;
}

function getOffset(el) {
  var _x = 0;
  var _y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}

function ShowOrHideCorrespondinginProductDiv(elementContainer, objPosition) {
  // alert(objPosition);

  // HorizontalDropDownMainContainer_Sublist_wrapper
  let elementContainer2 = elementContainer.getElementsByClassName(
    'HorizontalDropDownMainContainer_Sublist_wrapper'
  );

  if (elementContainer2) {
    //   alert(elementContainer2.length);

    for (let i = 0; i < elementContainer2.length; i++) {
      let tempEelement = elementContainer2[i];
      if (
        tempEelement.classList.contains('HorizontalDropDownMainContainer_Sublist_wrapper_Active')
      ) {
        tempEelement.classList.remove('HorizontalDropDownMainContainer_Sublist_wrapper_Active');
      }
    }

    if (elementContainer2[objPosition]) {
      if (
        elementContainer2[objPosition].classList.contains(
          'HorizontalDropDownMainContainer_Sublist_wrapper_Active'
        )
      ) {
      } else {
        elementContainer2[objPosition].classList.add(
          'HorizontalDropDownMainContainer_Sublist_wrapper_Active'
        );
      }
    }
  }
}

function ActivateHorizontalDropDownMainSingle(obj) {
  // alert("ActivateHorizontalDropDownMainSingle");

  if (obj) {
    // alert("obj found");

    if (obj == HorizontalDropDownMainActiveRow) {
      return;
    }
    // if there is another active cell deactive it

    if (HorizontalDropDownMainActiveRow) {
      // tbc
      DeactivateHorizontalDropDownMainSingle(HorizontalDropDownMainActiveRow);
    }

    StartActivationHorizontal(obj);

    HorizontalDropDownMainActiveRow = obj;

    // let elementItems = document.getElementsByClassName("HorizontalDropDownMainContainer_Sublist_wrapper_Active")[0];
    //  HorizontalDropDownMainActiveRow = elementItems;
  }
}

function DeactivateHorizontalDropDownMainSingle(HorizontalDropDownMainActiveRow) {
  //  let elementContainer = document.getElementById("DepartmentListTopNavAll_list");

  if (HorizontalDropDownMainActiveRow) {
    //   alert("de activate ran");

    if (
      HorizontalDropDownMainActiveRow.classList.contains(
        'HorizontalDropDownMainContainer_wrapper_Active'
      )
    ) {
      HorizontalDropDownMainActiveRow.classList.remove(
        'HorizontalDropDownMainContainer_wrapper_Active'
      );
    }
  }

  HorizontalDropDownMainActiveRow = null;
}

/**
 * Activate a menu row.
 */

function StartActivation(obj) {
  if (obj) {
    VerticalDropDownMainContainerClicked(obj);
  }
}

function StartActivationHorizontal(obj) {
  if (obj) {
    TopNavAllCatInDeptCatSelectMouseClick(obj);
  }
}

function ShowOrHideCorrespondinginCatDiv(objPosition) {
  let elementContainer = document.getElementsByClassName('HorizontalDropDownMainContainer')[0];

  if (elementContainer) {
    //   alert("element found");
    let elementItems = document.getElementsByClassName('HorizontalDropDownMainContainer_wrapper');

    for (let i = 0; i < elementItems.length; i++) {
      let tempEelement = elementItems[i];
      if (tempEelement.classList.contains('HorizontalDropDownMainContainer_wrapper_Active')) {
        tempEelement.classList.remove('HorizontalDropDownMainContainer_wrapper_Active');
      }

      //  elementItems[i].style.display = "none";

      //  alert(elementItems.id);
    }

    //  alert("objPosition " + objPosition);
    let elementDiv = elementItems[objPosition];

    if (elementDiv) {
      if (elementDiv.classList.contains('HorizontalDropDownMainContainer_wrapper_Active')) {
      } else {
        elementDiv.classList.add('HorizontalDropDownMainContainer_wrapper_Active');
      }
    }
  }
}
